import { jsx as _jsx } from "react/jsx-runtime";
import { Step, StepLabel, Stepper as MUIStepper, StepConnector as MUIStepConnector, styled, stepConnectorClasses as MUIStepConnectorClasses, } from "@mui/material";
import { convertPxToRem } from "../../util-functions";
import { Icon } from "../Icon";
const StyledStepper = styled(MUIStepper)(({ theme }) => ({
    "& .MuiStepLabel-root": {
        padding: 0,
        marginTop: `${convertPxToRem(-4)}`,
        marginBottom: `${convertPxToRem(-4)}`,
        ":has(.Mui-active)": {
            background: theme.palette.primaryWhite.main,
            position: "relative",
        },
    },
    "& .MuiStepLabel-label": Object.assign(Object.assign({ color: theme.palette.tertiaryText.main }, theme.typography.largeText), { fontWeight: `400 !important`, "&.Mui-active": {
            color: theme.palette.text.primary,
        }, "&.Mui-completed": {
            color: theme.palette.text.primary,
        } }),
    "& .MuiStepLabel-iconContainer": {
        zIndex: 1400, // without this the step label does not update to the completed color
    },
}));
const StyledConnectorLine = styled(MUIStepConnector)(({ theme }) => ({
    marginLeft: convertPxToRem(8),
    [`& .${MUIStepConnectorClasses.line}`]: {
        borderLeftWidth: convertPxToRem(2),
        height: convertPxToRem(48),
        borderColor: theme.palette.treezGrey[4],
    },
    [`&.${MUIStepConnectorClasses.active}`]: {
        [`& .${MUIStepConnectorClasses.line}`]: {
            borderColor: theme.palette.treezGreen[10],
        },
    },
    [`&.${MUIStepConnectorClasses.completed}`]: {
        [`& .${MUIStepConnectorClasses.line}`]: {
            borderColor: theme.palette.treezGreen[10],
        },
    },
}));
export const LinearStepper = ({ activeStep = 0, stepLabels, testId, }) => (_jsx(StyledStepper, Object.assign({ activeStep: activeStep, "data-testid": testId, orientation: "vertical", connector: _jsx(StyledConnectorLine, {}) }, { children: stepLabels.map((label, index) => (_jsx(Step, Object.assign({ "data-testid": testId && `${testId}-step-${index}` }, { children: _jsx(StepLabel, Object.assign({ "data-testid": testId && `${testId}-label-step-${index}`, icon: _jsx(Icon, { iconName: index === activeStep ? "Radio" : "Dot", fontSize: "small", color: index === activeStep
                    ? "green10"
                    : index < activeStep
                        ? "green10"
                        : "grey04", testId: index === activeStep
                    ? testId && `${testId}-activeStepIcon`
                    : index < activeStep
                        ? testId && `${testId}-completedStepIcon`
                        : testId && `${testId}-incompleteStepIcon` }) }, { children: label })) }), label))) })));
